<template>
  <div style="overflow: hidden;height:100%;">
    <el-container style="border: 1px solid #eee;overflow: hidden;height:100%;">
      <el-aside width="120px" class="left_nav_menus">
        <el-menu :default-active="activeIndex" @select="clickLeftMenu">
          <el-menu-item index="1">
            <i class="fa fa-file-text-o fa-fw fa-lg" aria-hidden="true"></i>&nbsp;客户盲订
          </el-menu-item>
          <el-menu-item index="3">
            <i class="fa fa-file-text-o fa-fw fa-lg" aria-hidden="true"></i>&nbsp;小订订单
          </el-menu-item>
          <el-menu-item index="2">
            <i class="fa fa-file-text-o fa-fw fa-lg" aria-hidden="true"></i>&nbsp;销售订单
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container style="overflow-y:auto;overflow-x:hidden;">
        <div style="width:100%;">
          <router-view></router-view>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.path.startWith("/order/blindOrder")) {
        vm.activeIndex = "1";
      }
      if (to.path.startWith("/order/zzOrder")) {
        vm.activeIndex = "2";
      }
      if (to.path.startWith("/order/smallOrder")) {
        vm.activeIndex = "3";
      }
    });
  },
  beforeRouteUpdate (to, from, next) {
    if (to.path.startWith("/order/blindOrder")) {
        this.activeIndex = "1";
      }
      if (to.path.startWith("/order/zzOrder")) {
        this.activeIndex = "2";
      }
      if (to.path.startWith("/order/smallOrder")) {
        this.activeIndex = "3";
      }
    next()
  },
  created() {},
  methods: {
    clickLeftMenu(index) {
      if (index == "1") {
        this.$router.push({
          path: "/order/blindOrder",
        });
      }
      if (index == "2") {
        this.$router.push({
          path: "/order/zzOrder",
        });
      }
      if (index == "3") {
        this.$router.push({
          path: "/order/smallOrder",
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .left_nav_menus .el-menu-item {
  padding-left: 20px !important;
}
</style>
